// extracted by mini-css-extract-plugin
module.exports = {"link":"_4f720283bf--link--q_e2P"};